import "babel-polyfill"

const formatDate = (date, fmt) => {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  };
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + '';
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str));
    }
  }
  return fmt;
}


// const awaitWrap = <T, U = any>(promise: Promise<T>): Promise<[U | null, T | null]> {
//   return promise
//    .then<[null, T]>((data: T) => [null, data])
//    .catch<[U, null]>(err => [err, null])
//  }

const awaitWrap = (promise) => {
  return promise
    .then((data) => [null, data])
    .catch((error) => [error, null])
}

const padLeftZero = (str) => {
  return ('00' + str).substr(str.length);
}

const getUrlKey = (name) => {
  return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null;
}

export default {
  formatDate,
  getUrlKey,
  awaitWrap
}









// WEBPACK FOOTER //
// ./src/lib/utils/index.js